import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Menu } from 'semantic-ui-react';
import { Link } from 'react-router';

const InternalControlsSummary = ({ selectedReview }) => {
  if (!selectedReview) return null;

  const fiscalYear =
    selectedReview.fiscalYear && selectedReview.fiscalYear.toString().slice(-2);

  return selectedReview &&
    ['FA1-PSR', 'FA2-CSR', 'Special', 'Comprehensive Review'].includes(
      selectedReview.reviewType
    ) &&
    selectedReview.fiscalYear > 2025 ? (
    <Menu.Item
      as={Link}
      to={`/review/fy${fiscalYear}/${selectedReview.reviewId}/internal_controls_summary`}
    >
      Internal Controls Summary
    </Menu.Item>
  ) : null;
};

InternalControlsSummary.propTypes = {
  selectedReview: PropTypes.object,
};

const mapStateToProps = state => ({
  selectedReview: state.review.selectedReview,
});

export default connect(mapStateToProps)(InternalControlsSummary);
